import { useQuery } from '@tanstack/react-query';
import { getInterestList } from '../api/interest';

export const useInterestList = (params) => {
  return useQuery({
    queryKey: ['interestList', params],
    queryFn: ({ signal }) => getInterestList(params, signal),
  });
};
